import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ClaimsList from "./claims-list/ClaimsList";
import * as claimActions from "../../store/actions/claims";
import * as appActions from "../../store/actions/app";
import Input from "../shared/ui/input/Input";
import styles from "./ViewClaims.module.css";
import NoData from "../shared/ui/no-data/NoData";
import { baseTitle } from "../../constants/messages";
import { PERSONAL, COMMERCIAL } from "../../constants/keys";

function ViewClaims() {
  const dispatch = useDispatch();
  let isLoading = useSelector((state) => state.app.isLoading);
  let personalClaims = useSelector((state) => state.claims.personalClaims);
  let commercialClaims = useSelector((state) => state.claims.commercialClaims);
  const policyType = useSelector((state) => state.app.policyType);
  const [searchClaims, setSearchClaims] = useState([]);
  const [claims, setClaims] = useState();

  const handleSearch = (event) => {
    if (event.target.value === "") {
      setSearchClaims(claims);
    } else {
      if (event.target.id === "claimNumber") {
        setSearchClaims(
          claims.filter((i) => i.claimNumber.startsWith(event.target.value))
        );
      } else if (event.target.id === "lossDate") {
        setSearchClaims(
          claims.filter((i) => i.lossDate.includes(event.target.value))
        );
      } else if (event.target.id === "policyNumber") {
        setSearchClaims(
          claims.filter((i) => i.policyNumber.includes(event.target.value))
        );
      }
    }
  };

  useEffect(() => {
    if (policyType.personal && policyType.commercial) {
      dispatch(appActions.setButtonHeader(true));
    } else {
      dispatch(appActions.setButtonHeader(false));
    }
  }, [dispatch, policyType.personal, policyType.commercial]);

  useEffect(() => {
    if (policyType.active) {
      if (policyType.active === PERSONAL) {
        if (personalClaims) {
          setClaims(personalClaims);
        } else {
          dispatch(claimActions.getClaims(policyType.personal, policyType.active));
        }
      } else if (policyType.active === COMMERCIAL) {
        if (commercialClaims) {
          setClaims(commercialClaims);
        } else {
          dispatch(claimActions.getClaims(policyType.commercial, policyType.active));
        }
      }
    }
  }, [dispatch, personalClaims, commercialClaims, policyType.active])

  useEffect(() => {
    document.title = baseTitle + " - View Claims";
  }, []);

  return (
    <div className={styles.container}>
      <div className="formRow">
        <h1 className={styles.header}>Your Claims</h1>
        <span className="additionalText">
          (*) indicates multiple claimant names. Click claim to view summary for
          details.
        </span>
      </div>
      {claims?.length > 0 && !isLoading ? (
        <>
          <div className={styles.searchRow}>
            <Input width="33%">
              <input
                id="claimNumber"
                placeholder="Search Claim/Reference Number"
                onChange={(e) => handleSearch(e)}
                aria-label="Search Claim/Reference Number"
              />
            </Input>
            <Input width="33%">
              <input
                id="lossDate"
                placeholder="Search Loss Date"
                onChange={(e) => handleSearch(e)}
                aria-label="Search Loss Date"
              />
            </Input>
            <Input width="33%">
              <input
                id="policyNumber"
                placeholder="Search Policy Number"
                onChange={(e) => handleSearch(e)}
                aria-label="Search Policy Number"
              />
            </Input>
          </div>
          {!isLoading && (
            <ClaimsList
              claims={searchClaims.length > 0 ? searchClaims : claims}
            />
          )}
        </>
      ) : (
        <NoData message="NO CLAIMS" />
      )}
    </div>
  );
}

export default ViewClaims;
